module.exports = __webpack_public_path__ + "img/vmwarevsphere.32594541.svg";